<div class="modal-dialog" data-cy="rename-folder-modal">
  <div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="{{getTitleTranslationKey()}}" [id]="dialogTitleId"></h4>
      <button
        class="close-btn"
        type="button"
        [attr.aria-label]="('common_close' | translate)"
        (click)="dismiss()">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      <div class="form-div" [formGroup]="form" #content goRequiredFieldsNote>
        @if (data.createMode && folders.length > 0) {
          <ngx-folder-tree-select
            formControlName="selectedFolder"
            [folders]="folders"
            [showNoneOption]="true"
            [maxDepth]="2"
            (availableFoldersChange)="onAvailableFoldersChange($event)">
          </ngx-folder-tree-select>
        }

        <mat-form-field appearance="outline">
          <mat-label translate="add-collection-folder_name-label"></mat-label>
          <input
            matInput
            formControlName="name"
            data-cy="folderName"
            [placeholder]="getPlaceholderKey() | translate"
            maxlength="191"/>
          @if (form.controls.name.hasError('required')) {
            <mat-error
              translate="add-collection-folder_required">
            </mat-error>
          }
          @if (form.controls.name.hasError('maxlength')) {
            <mat-error
              translate="add-collection-folder_maxlength">
            </mat-error>
          }
          @if (form.controls.name.hasError('duplicate')) {
            <mat-error
              translate="add-collection-folder_unique-name">
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="goreact-modal-footer">
      <button
        type="button"
        (click)="dismiss()"
        translate="common_cancel"
        class="goreact-btn tertiary-btn cancel-btn">
      </button>
      <button
        type="submit"
        data-cy="rename-folder"
        class="goreact-btn primary-btn"
        [disabled]="isSubmitting"
        [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
        (click)="submit(form)"
        translate="{{getButtonName()}}">
      </button>
    </div>
  </div>
</div>
